import { Injectable } from '@angular/core';
import { UserService } from '@/core/services/open-api/user.service';
import { Account } from '@/core/models/account';
import { Observable, startWith, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OnboardingService {
    steps$: Observable<boolean[] | undefined>;

    constructor(public readonly userService: UserService) {
        this.steps$ = this.userService.accountSettingsChanged$.pipe(
            startWith(undefined), // enforce initial loading
            switchMap(() => this.userService.loadAccount()),
            map((account) => {
                return OnboardingService.getOnboardingSteps(account);
            }),
        );
    }

    public static getOnboardingSteps(account: Account): boolean[] | undefined {
        if (!account || !account.accountSettings || !account.accountSettings.onboarding) {
            return undefined;
        }
        let onboarding = account.accountSettings.onboarding;

        if (onboarding === 'COMPLETED') {
            return undefined;
        }

        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((typeof onboarding as any) === 'string') {
                onboarding = JSON.parse(onboarding);
            }
        } catch (e) {
            console.error('Failed to parse onboarding settings:', e);
            return undefined;
        }

        return Array.isArray(onboarding) ? onboarding : undefined;
    }
}
